<template>
  <div :class="sectionClasses">
    <slot />
  </div>
</template>
<script lang="ts" setup>
const props = defineProps({
  padding: {
    type: String,
    default: '20px',
    required: false,
  },
});
const { padding } = toRefs(props);
const sectionClasses = computed(() => ({
  'padding-wrapper h-full': true,
  [padding.value ? paddingClasses[padding.value] : 'p-5']: true,
}));
const paddingClasses: Record<string, string> = {
  '20px': 'lg:p-5',
  '0px': 'lg:p-0',
};
</script>
<style></style>
